import { useContext, useEffect, useRef, useState } from "react";

import { FlightAPIContext } from "contexts/flight_api_context";
import { ClassroomInfoType } from "shared/types";

export const useHasClassStarted = (classInfo: ClassroomInfoType) => {
  const flightAPI = useContext(FlightAPIContext);
  const serverMillisecondsRef = useRef(flightAPI.getServerMilliseconds());
  const classStartTime = classInfo.date;
  const [hasClassStarted, setHasClassStarted] = useState(
    !!classStartTime && serverMillisecondsRef.current >= classStartTime,
  );

  useEffect(() => {
    if (!classStartTime || hasClassStarted) return;

    const timeout = setTimeout(() => {
      setHasClassStarted(true);
    }, classStartTime - serverMillisecondsRef.current);

    return () => {
      clearTimeout(timeout);
    };
  }, [classStartTime, hasClassStarted, serverMillisecondsRef]);

  return hasClassStarted;
};
